export default __webpack_public_path__ + "static/zoom-b8ef420a7a9582b3f3bad53af7402c3e.png";